import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { showModal } from 'actions/common'
import { promoCodeSetEditingPromoCode } from 'actions/promo-code'
import { PROMO_CODE_MODAL } from 'constants/modal-constants'
import { formatDateTimeNice } from 'utils/datetime'
import { formatPriceDecimals } from 'utils/format'

import PromoCodeListItem from './promo-code-list-item'


export const getAppliesToText = ({ partner, eventGroup, sellableItem, deal }) => {
  if (partner) {
    return 'All Events'
  }

  let text = ''
  if (eventGroup) {
    text += eventGroup.name
  }

  if (sellableItem) {
    const salePriceStr = formatPriceDecimals(sellableItem.salePrice, 'GBP')
    text += ` - ${sellableItem.groupName} ${sellableItem.name} - ${salePriceStr}`
  } else if (deal) {
    const salePriceStr = formatPriceDecimals(deal.salePrice, 'GBP')
    const startTimeStr = formatDateTimeNice(deal.startTime)
    text += ` - ${startTimeStr} - ${salePriceStr}`
  }

  return text
}


export class PromoCodeListItemContainer extends Component {

  constructor(props) {
    super(props)

    this.onEditClick = this.onEditClick.bind(this)
  }

  onEditClick() {
    this.props.promoCodeSetEditingPromoCode(this.props.code.id)
    this.props.showModal(PROMO_CODE_MODAL)
  }

  render() {
    return (
      <PromoCodeListItem
        code={this.props.code}
        appliesToText={getAppliesToText(this.props.code)}
        onEditClick={this.onEditClick}
      />
    )
  }

}


PromoCodeListItemContainer.propTypes = {
  code: PropTypes.object,
  promoCodeSetEditingPromoCode: PropTypes.func,
  showModal: PropTypes.func,
}

const mapDispatchToProps = {
  promoCodeSetEditingPromoCode,
  showModal,
}

export default connect(null, mapDispatchToProps)(PromoCodeListItemContainer)




/** WEBPACK FOOTER **
 ** ./src/components/promo-code-list/promo-code-list-item/promo-code-list-item-container.js
 **/